// PublicBrand — the product mark + name at the head of the public pages
// (landing, sign-in, the terms gate), pure. The public surfaces use the fixed
// brand palette (`brand-*`), so they look apart from the app on purpose.

export { PublicBrand };

import { appName } from "@bilda/app/identity";
import type { ReactNode } from "react";
import { Icon } from "../Icon/Icon.js";
import "./PublicBrand.css";

const PublicBrand = (): ReactNode => (
    <span className="bilda-public-brand">
        <span className="bilda-public-brand__mark" aria-hidden="true">
            <Icon name="sparkle" size="sm" />
        </span>
        <span className="bilda-public-brand__name">{appName}</span>
    </span>
);
